import { NetworkVisibility, RoleType } from '@tribeplatform/gql-client/types'

import { isUrlPointsWithinApp, loginUrlWithRedirect } from '../app.lib'
import { getSearchParams } from '../useQuery'

export const privateNetworkGuard = (
  roleType: RoleType,
  networkVisibility: NetworkVisibility,
): boolean => {
  const { pathname, search } = window.location
  const query = getSearchParams(search)
  // redirect guests to the login page if auth=true query param exists
  if (
    query?.auth === 'true' &&
    roleType === RoleType.guest &&
    isUrlPointsWithinApp(pathname)
  ) {
    window.location.href = loginUrlWithRedirect(pathname)
    return true
  }

  // Checking for guests user visiting a private network
  if (
    networkVisibility === NetworkVisibility.private &&
    roleType === RoleType.guest &&
    isUrlPointsWithinApp(pathname)
  ) {
    window.location.href = loginUrlWithRedirect(pathname)
    return true
  }

  return false
}
